module.exports = __webpack_public_path__ + "img/logo_icon.b1543166.svg";